import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { formatINR, fmtDate } from "@/lib/roles";
import { Loader2, Receipt as ReceiptIcon } from "lucide-react";

export default function ReceiptList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/payments/history?limit=100").then((r) => setItems(r.data.items || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6" data-testid="receipts-list">
      <div>
        <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">History</div>
        <h1 className="text-2xl sm:text-3xl font-heading font-semibold flex items-center gap-2"><ReceiptIcon className="w-6 h-6" /> Receipts</h1>
      </div>
      <Card>
        <CardContent className="p-0">
          {loading ? <div className="p-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin" /></div> : items.length === 0 ? (
            <div className="p-10 text-center text-slate-500">No receipts yet.</div>
          ) : (
            <table className="w-full text-sm" data-testid="receipts-table">
              <thead className="bg-slate-50 dark:bg-slate-800 text-xs uppercase tracking-wider text-slate-500">
                <tr><th className="text-left py-3 px-4">Receipt</th><th className="text-left py-3 px-4">Date</th><th className="text-left py-3 px-4">Module</th><th className="text-left py-3 px-4">Method</th><th className="text-right py-3 px-4">Amount</th><th></th></tr>
              </thead>
              <tbody>
                {items.map((p) => (
                  <tr key={p.id} className="border-t hover:bg-slate-50 dark:hover:bg-slate-800/50">
                    <td className="py-3 px-4 font-mono text-xs">{p.receipt_number || p.payment_id}</td>
                    <td className="py-3 px-4">{fmtDate(p.completed_at)}</td>
                    <td className="py-3 px-4 capitalize">{(p.module || "").replace("_", " ")}</td>
                    <td className="py-3 px-4 uppercase text-xs">{p.method}</td>
                    <td className="py-3 px-4 text-right font-mono font-semibold">{formatINR(p.amount)}</td>
                    <td className="py-3 px-4 text-right">
                      <Link to={`/receipts/${p.receipt_number || p.payment_id}`}>
                        <Button size="sm" variant="ghost">View</Button>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
